import React from 'react';
import { cn } from 'lib/utils';

interface IProps {
  isLoading: boolean;
  size?: 'sm' | 'md' | 'lg';
  color?: 'primary' | 'gray' | 'white';
  className?: string;
}

const sizeMap = {
  sm: { width: 16, height: 16, border: 2 },
  md: { width: 24, height: 24, border: 2 },
  lg: { width: 32, height: 32, border: 3 },
};

const colorMap = {
  primary: 'var(--color-green-400)',
  gray: 'var(--color-gray-blue-50)',
  white: 'var(--color-gray-blue-0)',
};

const LocalSpinner = ({
  isLoading,
  size = 'md',
  color = 'primary',
  className = '',
}: IProps): JSX.Element | null => {
  if (!isLoading) return null;

  const { width, height, border } = sizeMap[size];
  const borderColor = colorMap[color];

  return (
    <div
      data-testid="spinner-local"
      className={cn('animate-spin rounded-full', className)}
      style={{
        width,
        height,
        borderWidth: border,
        borderStyle: 'solid',
        borderColor: `${borderColor} ${borderColor} ${borderColor} transparent`,
      }}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  );
};

export default LocalSpinner;
